
import React from "react";
import { Link } from "react-router-dom";
import { useLanguage } from "@/context/LanguageContext";
import { Instagram, Globe, Heart } from "lucide-react";

export const Footer: React.FC = () => {
  const { t, language } = useLanguage();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-palsustain-green text-white py-12 mt-20">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Logo & About */}
          <div>
            <Link to="/" className="flex items-center mb-4">
              <span className="text-2xl font-bold">Palsustain</span>
            </Link>
            <p className="text-white/80 mb-4">
              {t("home.about.description")}
            </p>
            <div className="flex space-x-4 rtl:space-x-reverse">
              <a 
                href="https://instagram.com/palsustain2024" 
                target="_blank" 
                rel="noopener noreferrer"
                aria-label="Follow us on Instagram"
                className="text-white hover:text-palsustain-beige transition-colors"
              >
                <Instagram className="h-5 w-5" />
              </a>
              <a 
                href="https://palsustain.org" 
                target="_blank" 
                rel="noopener noreferrer"
                aria-label="Visit our website"
                className="text-white hover:text-palsustain-beige transition-colors"
              >
                <Globe className="h-5 w-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-bold text-lg mb-4">{t("nav.home")}</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-white/80 hover:text-palsustain-beige transition-colors">
                  {t("nav.home")}
                </Link>
              </li>
              <li>
                <Link to="/sdgs" className="text-white/80 hover:text-palsustain-beige transition-colors">
                  {t("nav.sdgs")}
                </Link>
              </li>
              <li>
                <Link to="/media" className="text-white/80 hover:text-palsustain-beige transition-colors">
                  {t("nav.media")}
                </Link>
              </li>
              <li>
                <Link to="/journey" className="text-white/80 hover:text-palsustain-beige transition-colors">
                  {t("nav.journey")}
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div className={language === "ar" ? "text-right" : "text-left"}>
            <h3 className="font-bold text-lg mb-4">{t("nav.contact")}</h3>
            <div className="flex items-center mb-2">
              <a 
                href="mailto:contact@palsustain.org" 
                className="text-white/80 hover:text-palsustain-beige transition-colors"
              >
                contact@palsustain.org
              </a>
            </div>
            <div className="mt-4">
              <p className="text-white/80">
                {t("footer.follow")}: <a 
                  href="https://instagram.com/palsustain2024" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="underline hover:text-palsustain-beige transition-colors"
                >
                  @palsustain2024
                </a>
              </p>
            </div>
          </div>
        </div>

        <div className="border-t border-white/20 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-sm text-white/70 mb-4 md:mb-0">
            &copy; {currentYear} Palsustain. {t("footer.rights")}.
          </p>
          <div className="flex items-center text-sm text-white/70">
            <span className="flex items-center">
              {language === "ar" ? "صنع بـ " : "Made with "}
              <Heart className="h-4 w-4 mx-1 text-palsustain-coral" />
              {language === "ar" ? " في فلسطين" : " in Palestine"}
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
